'use strict';

module.exports = {
    /**
     * 拍照或从手机相册中选取图片<br />
     * 对应native接口：chooseImage
     * @method hysdk.chooseImage
     * @category Image
     * @example ./chooseImage.js[1-39]
     * @description
     *
     * <table style="text-align:center">
     *     <tr>
     *         <th colspan="2">参数</th>
     *         <th>类型</th>
     *         <th>说明</th>
     *         <th>iOS</th>
     *         <th>Android</th>
     *         <th>touch</th>
     *         <th>wechat</th>
     *     </tr>
     *     <tr>
     *         <td colspan="2">sizeType</td>
     *         <td>string array</td>
     *         <td>指定原图还是压缩图，默认二者都有</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">√</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">sourceType</td>
     *         <td>string array</td>
     *         <td>指定来源是相册还是相机，默认二者都有</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">localIds</td>
     *         <td>string array</td>
     *         <td>上次已经选择过的图片<br/>从15年10月iOS新架构发布以后<br/>由于iOS公共相册组件存在bug，iOS暂时不支持使用</td>
     *         <td>X</td>
     *         <td>√</td>
     *         <td>X</td>
     *         <td>√</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">count</td>
     *         <td>number</td>
     *         <td>允许用户选择图片的最大数，默认为9</td>
     *         <td>大客户端 vid: 80011102+<br/>独立客户端 HytiveLib: 1.1.1+</td>
     *         <td>大客户端browser vid: 27+</td>
     *         <td>X</td>
     *         <td>√</td>
     *     </tr>
     *     <tr>
     *         <td rowspan="2">thumbnail</td>
     *         <td>maxPixel</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>缩略图长宽最大尺寸，<br/>可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为原图、1200、800、400</td>
     *         <td>新大客户端、独立客户端 HytiveLib: 1.3.0+</td>
     *         <td>大客户端browser vid: 29+</td>
     *         <td>X</td>
     *         <td>X</td>
     *     </tr>
     *     <tr>
     *         <td>quality</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>缩略图JPG压缩参数，尺寸不变。<br/>为1-100之间的整数。<br/>也可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为100、90、70、50</td>
     *         <td>独立客户端 HytiveLib: 1.3.0+</td>
     *         <td>大客户端browser vid: 29+</td>
     *         <td>X</td>
     *         <td>X</td>
     *     </tr>
     * </table>
     *
     * 返回字段说明：
     *
     * | 返回字段 | 类型 | 说明 | IOS | Android | touch | wechat |
     * | :----: | :---: | :---: | :---: | :----: | :-----: | :-----: |
     * | localIds | string array | 返回选定照片的本地ID列表<br/>localId可为img标签的src属性 | √ | √ | X | √ |
     * | thumbnails | string array | 只有请求中设置了thumbnail参数才会返回<br/>返回选定照片的本地缩略图ID列表<br/>thumbnail可为img标签的src属性 | 新大客户端、独立客户端 HytiveLib: 1.3.0+ | 大客户端browser vid: 29+ | X | X |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    chooseImage: {
        hy: {
            key: 'chooseImage'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    //TODO 是否还支持缩略图 thumbnails
                    localIds: ret.localIds
                };
            }
        }
    },
    /**
     * 上传图片 <br />
     * 对应native接口：uploadImage.v1
     * @method hysdk.uploadImage
     * @category Image
     * @example ./uploadImage.js[1-30]
     * @description
     *
     * 请求参数说明：
     * <table style="text-align:center">
     *     <tr>
     *          <th width="120">参数</th>
     *          <th width="80">类型</th>
     *          <th width="220">说明</th>
     *          <th width="80">iOS</th>
     *          <th width="80">Android</th>
     *          <th width="80">touch</th>
     *          <th width="80">wechat</th>
     *      </tr>
     *      <tr>
     *          <td>localId</td>
     *          <td>string array</td>
     *          <td>需要上传的图片的本地ID，由chooseImage接口获得</td>
     *          <td rowspan="6">√</td>
     *          <td rowspan="6">√</td>
     *          <td rowspan="6">X</td>
     *          <td rowspan="6">X</td>
     *      </tr>
     *      <tr>
     *          <td>serverAddress</td>
     *          <td>string</td>
     *          <td>上传服务地址。必须是在qunar域下。</td>
     *      </tr>
     *     <tr>
     *         <td>serverParams</td>
     *         <td>map</td>
     *         <td>post到服务器的参数map（可选）</td>
     *     </tr>
     *     <tr>
     *         <td>fileKey</td>
     *         <td>string</td>
     *         <td>服务器端接口中文件对应的参数名<br/>（可选，默认值为"file"）</td>
     *     </tr>
     *     <tr>
     *         <td>maxPixel</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>上传图片长宽最大尺寸，<br/>可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为原图、1200、800、400</td>
     *     </tr>
     *     <tr>
     *         <td>quality</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>上传图片JPG压缩参数，尺寸不变。<br/>为1-100之间的整数。<br/>也可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为100、90、70、50</td>
     *     </tr>
     * </table>
     *
     * 返回字段说明：
     *
     * | 返回字段 | 类型 | 说明 | IOS | Android | touch | wechat |
     * | :-----: | :-----: | :-----: | :-----: | :-----: | :-----: | :-----: |
     * | responseData | string | 服务器返回的数据 | √ | √ | X | X(object) |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    uploadImage: {
        hy: {
            key: 'uploadImage.v1'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    serverId: ret.serverId
                };
            }
        }
    },
    /**
     * 预览图片<br />
     * 对应native接口：previewImage
     * @method hysdk.previewImage
     * @category Image
     * @example ./previewImage.js[1-6]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | current | String | 当前显示的图片链接 | √ | 常用参数，仅微信支持 |
     * | urls | Array | 需要预览的图片链接列表 | √ | 常用参数，仅微信支持 |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    previewImage: {
        hy: {
            key: 'previewImage'
        },
        wechat: {
            key: 'previewImage'
        }
    },
    /**
     * 下载图片<br />
     * 对应native接口：downloadImage
     * @method hysdk.downloadImage
     * @category Image
     * @example ./downloadImage.js[1-12]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | serverId | String | 需要下载的图片的服务器端ID，由uploadImage接口获得 | √ | 常用参数，仅微信支持 |
     * | isShowProgressTips | Number | 显示进度提示 | √ | 常用参数，仅微信支持 |
     * | success | Function | success 回调 | X | 常用参数，仅微信支持，可获取图片下载后的本地ID
     * | fail | Function | fail 回调 | X | 常用参数，仅微信支持
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    downloadImage: {
        hy: {
            key: 'downloadImage'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    localId: ret.localId
                };
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/image.js
// module id = 16
// module chunks = 0 2 4